import React from 'react';
import cx from 'classnames';
import styles from './styles.module.css';

export const Page: React.FC<{
  variant?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ variant, className, children, ...props }) => (
  <div
    className={cx(
      styles.main,
      { [styles[`${variant}`]]: variant },
      styles.className,
      className
    )}
    {...props}
  >
    {children}
  </div>
);
